module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-5eaf404087be0e7d4b48e9d89230765e.svg";